module.exports = "/lucky-balls/img/bigball/BigBall_003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_003.png
// module id = 898
// module chunks = 0